export default __webpack_public_path__ + "static/media/water-droplets-bg.85708c16.jpg";